var React = require('react');

function Bang8 (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("polygon",{"className":"st0","points":"344.7,399.7 328.7,364.4 328.7,364.4 304.3,310.6 304.3,310.6 289.2,277.3 257.8,291.5 232,303.2 \n\t311.9,479.5 369.1,453.6 344.7,399.7 ","key":1})]);
}

Bang8.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 612 792","style":{"enableBackground":"new 0 0 612 792"},"xmlSpace":"preserve"};

module.exports = Bang8;

Bang8.default = Bang8;
